<template>
  <v-icon @click="$emit('click', $event)" color="gray">
    edit
  </v-icon>
</template>

<script>
export default {
  name: 'AppButtonEdit',
  inheritAttrs: false,
}
</script>
